module.exports = __webpack_public_path__ + "img/02.f4c8d100.jpg";